import React, { useEffect, useState } from 'react'
import images from 'assets/images/Guidelines_page-0001.jpg'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import Api from 'utils/api'

export const INVITE_INVALID_MESSAGE = 'This invite link is invalid or expired'
export const INVITE_PASSWORD_SET_MESSAGE =
  'You have already set a password. Sign in, or reset your password if you have forgotten it.'

// The invite token authenticates these calls (setupAxios sends it for /create-password);
// it is never stored as the session, and a 401 must not clear the visitor's own session.
export async function submitInvitePassword({ form, token }) {
  const { error, response } = await Api('/auth/invite/password', 'post', {
    payload: {
      password: form.password,
      confirmPassword: form.password,
      token: 'Bearer ' + token,
    },
    keepSession: true,
  })
  if (error || !response) return { error: { message: error?.message || INVITE_INVALID_MESSAGE } }
  return { response }
}

function Useronboard() {
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const token = queryParams.get('token')
  const pathname = window.location.pathname.split('/')
  const navigate = useNavigate()
  const [user, setUser] = useState({})
  const [status, setStatus] = useState(token ? 'loading' : 'invalid')

  const loadInvite = async () => {
    if (!token) return
    const { error, response } = await Api('/auth/invite', 'get', { keepSession: true })
    if (error || !response?.data) return setStatus('invalid')
    setUser(response.data)
    setStatus(response.data.passwordSet ? 'passwordSet' : 'ready')
  }

  useEffect(() => {
    loadInvite()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token])

  return (
    <div className='tw-grid md:tw-h-screen tw-items-stretch md:tw-grid-cols-2 md:tw-p-0 tw-p-5'>
      <div className='md:tw-flex tw-items-center tw-justify-center d:tw-h-screen tw-hidden tw-bg-night'>
        <div className='tw-fixed tw-top-20 tw-left-20'>
          {pathname.length > 2 && (
            <div className='tw-inline-block tw-mb-4'>
              <span onClick={() => navigate(-1)} className='tw-cursor-pointer' style={{ color: 'white' }}>
                ← back
              </span>
            </div>
          )}
        </div>
        <div className='tw-block tw-bg-canvas tw-rounded-2xl tw-px-10 tw-py-8 tw-shadow-pop'>
          <img src={images} alt='' className='tw-w-72' />
        </div>
      </div>

      <div class='tw-flex md:tw-items-center md:tw-justify-center md:tw-px-4 tw-py-8'>
        <div class='md:tw-max-w-sm tw-w-full'>
          {/* <div class='md:tw-mb-12'>
            {pathname.length > 1 && (
              <div  class='tw-block tw-mb-4'>
                <span class='tw-cursor-pointer'>← back</span>
              </div>
            )}
          </div> */}
          {status === 'invalid' && (
            <p role='alert' class='tw-text-xl'>
              {INVITE_INVALID_MESSAGE}
            </p>
          )}
          {status === 'passwordSet' && (
            <p role='alert' class='tw-text-xl'>
              {INVITE_PASSWORD_SET_MESSAGE}{' '}
              <span onClick={() => navigate('/login')} className='tw-cursor-pointer tw-text-electricGreen hover:tw-underline'>
                Sign in
              </span>
            </p>
          )}
          {status === 'ready' && (
            <>
              <h1 class='tw-font-heading  md:tw-text-4xl tw-font-semibold tw-mb-2 tw-text-4xl'>
                Hi {user?.fullName}
                <span class='tw-text-electricGreen'>,</span>
              </h1>
              <strong class='tw-block tw-mb-4 tw-text-xl'>
                Create a password to start your session
              </strong>
              <Outlet />
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default Useronboard
